import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import format from 'utils/formatMoney'
import styles from 'modules/Services/Account/subcomponents/Money/money.module.scss'

const POSITIVE_STATUSES = ['approved']

const Money = ({ number = 0, currency = 'RUB', status = '' }) => (
  <span
    className={clsx(styles['money'], styles['status_' + status])}
    dangerouslySetInnerHTML={{
      __html:
        (POSITIVE_STATUSES.includes(status) ? '+ ' : '') +
        format(number, currency),
    }}
  />
)

export default Money

Money.propTypes = {
  number: PropTypes.number,
  currency: PropTypes.string,
  status: PropTypes.string,
}
